import { render, staticRenderFns } from "./grupoAgendaViewer.vue?vue&type=template&id=2ef29a84&"
import script from "./grupoAgendaViewer.vue?vue&type=script&lang=js&"
export * from "./grupoAgendaViewer.vue?vue&type=script&lang=js&"
import style0 from "./grupoAgendaViewer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports